module.exports = __webpack_public_path__ + "static/media/kevin.0c284567.jpg";